import { useLocation } from 'react-router-dom';
import { getUserInfo } from '@shared/api/client';
import { ROUTES } from '@/app/router/routes';
import FallingRewardItem from './FallingRewardItem';

// 會出現飄落彩蛋的頁面清單：首頁、文星點燈、中台心傳、護博會
const ENABLED_PATHS = [ROUTES.HOME, ROUTES.LANDING, ROUTES.WISDOM_LAMP, ROUTES.TRANSMISSION, ROUTES.GUARDIAN_EXPO];

// 彩蛋功能暫時整體隱藏（TODO：之後要恢復時改回 false）
const HIDDEN = false;

/**
 * 自帶登入狀態與路由判斷的彩蛋掛載點，直接放進各頁面共用的 Layout Wrapper 即可，
 * 不需要每個頁面各自 import FallingRewardItem 並自行判斷 isLoggedIn
 */
const FallingRewardMount = () => {
    const location = useLocation();
    const isLoggedIn = !!getUserInfo();

    if (HIDDEN || !isLoggedIn || !ENABLED_PATHS.includes(location.pathname)) return null;

    return <FallingRewardItem />;
};

export default FallingRewardMount;
